import React from 'react';
import {Text} from 'native-base';
import {useTheme} from 'styled-components/native';

export interface InnerCircleTextProps {
  text: string;
  isSevenStars: boolean;
}

const InnerCircleText: React.FC<InnerCircleTextProps> = ({
  text,
  isSevenStars,
}) => {
  const theme = useTheme() as any;
  const {white, shuttleGray} = theme.colors;

  return (
    <Text
      fontFamily="body"
      fontWeight="bold"
      fontSize="9px"
      lineHeight={isSevenStars ? '12px' : '9px'}
      letterSpacing="1px"
      color={isSevenStars ? white : shuttleGray}
      textTransform="uppercase">
      {text}
    </Text>
  );
};

export default InnerCircleText;
